import {
  LOAD_CAMPAIGN_SUCCESS,
  LOAD_CAMPAIGN_ERROR,
  LOAD_CAMPAIGN,
} from './constants';

export function loadingCampaign(campaignId, silent = false) {
  return {
    type: LOAD_CAMPAIGN,
    campaignId,
    silent,
  };
}

export function loadCampaignError(error) {
  return {
    type: LOAD_CAMPAIGN_ERROR,
    error,
  };
}

export function loadingCampaignSuccess(campaign) {
  return {
    type: LOAD_CAMPAIGN_SUCCESS,
    campaign,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/acr-campaign/actions.js
 **/